import React, { forwardRef } from "react";
import type { TuvisIconNamesType } from "@whatslly/types/UI-V2/BaseElements/Svg/TuvisIconNamesType";
export const SvgV2 = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement> & { iconName: TuvisIconNamesType }>(({ iconName, ...props }, ref) => {
  const href = `#tvs-${iconName}`;

  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" {...props}>
      <use href={href} />
    </svg>
  );
});
